import React from "react";
import SEO from "@/components/SEO";
import NewsArticleLayout from "@/components/NewsArticleLayout";

const DentalPaymentOptionsAustraliaPage = () => {
  return (
    <NewsArticleLayout
      title="Dental Payment Options in Australia: How to Manage Treatment Costs"
      date="February 2026"
      author="Y3 Smiles Dental"
    >
      <SEO title="Dental Payment Plans Broadmeadows | Y3 Smiles Dental" description="Explore dental payment options in Australia, including Medicare, private health, and payment plans." image="/og-reception.jpg" />
      <p>
        Dental costs can feel overwhelming, but there are several ways to manage treatment expenses in Australia. The
        right approach depends on your eligibility, insurance cover, and treatment priorities.
      </p>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Payment Options Explained</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Private health insurance:</strong> Claim rebates via HICAPS, paying the gap amount.</li>
          <li><strong>Medicare CDBS (kids):</strong> Eligible children can access benefits for basic dental services.</li>
          <li><strong>Interest-free payment plans:</strong> Spread payments over time where available.</li>
          <li><strong>Staged treatment planning:</strong> Prioritise urgent care first, then complete elective work later.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Pros</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Makes essential care more accessible</li>
          <li>Helps reduce upfront costs</li>
          <li>Supports long-term oral health planning</li>
        </ul>
        <h2 className="text-2xl font-semibold">Cons</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Eligibility and approval requirements may apply</li>
          <li>Some options have limits or exclusions</li>
          <li>Costs still vary by clinical need</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Indicative Australian Price Ranges</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Check-up: $80 – $180</li>
          <li>Scale and clean: $150 – $300</li>
          <li>Filling: $200 – $350 (up to $550 for complex cases)</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Local Service Area</h2>
        <p>
          Y3 Smiles Dental supports patients across Broadmeadows and nearby suburbs within 10 km, including Glenroy,
          Dallas, Meadow Heights, Jacana, Coolaroo, Roxburgh Park, Campbellfield, Fawkner, Westmeadows, and Hadfield.
        </p>
      </section>

      <div className="bg-neutral-50 border border-primary/10 rounded-2xl p-6 text-sm text-neutral-700">
        ⚠️ Educational only. All costs are indicative. Final treatment decisions and fees depend on individual assessment,
        in line with AHPRA advertising guidelines.
      </div>
    </NewsArticleLayout>
  );
};

export default DentalPaymentOptionsAustraliaPage;
